module.exports = __webpack_public_path__ + "static/g1-aaca9d54dc00dc502be86c990361dee1.svg";